<template>
  <div class="genre-list">
    <span
      class="genre genre-all"
      :class="{ selected: allGenresSelected }"
      @click="allGenresToggled"
      >{{ allGenresSelected ? "すべて解除" : "すべて選択" }}</span
    >
    
    <span
      v-for="genre in genreList"
      :key="genre.id"
      class="genre"
      :class="{ selected: isGenreSelected(genre.id) }"
      @click="genreToggled(genre.id)"
      >{{ genre.name }}</span
    >
  </div>
</template>

<script>
export default {
  props: ["allGenresSelected", "genreList", "isGenreSelected"],
  methods: {
    allGenresToggled() {
      this.$emit("allGenresToggled")
    },

    genreToggled(id) {
      this.$emit("genreToggled", id)
    }
  }
};
</script>

<style src="./GenreList.css"></style>
